module.exports = __webpack_public_path__ + "img/logo-xyz.84d8e6f1.png";